/**
 * Login screen color definitions
 */
import {palette, createColor} from './palette.colors';

export const helperColors = {
  mainBackground: createColor(palette.gray.lightWhite, palette.dark.background),
  background: createColor(
    palette.gray.backgroundLight,
    palette.gray.backgroundLight,
  ),
  border: createColor(palette.gray.iconLight, palette.dark.techBorder),
  filterBorderColor: createColor(
    palette.gray.borderLight,
    palette.gray.borderLight,
  ),
  filterBackground: createColor(palette.gray.white, palette.dark.content),
  topCardBorder: createColor(palette.gray.divider, palette.gray.divider),
  topTitle: createColor(palette.gray.darkest, palette.dark.text),
  topSubTitle: createColor(palette.gray.dark, palette.dark.textAlt),
  textColor: createColor(palette.gray.darker, palette.dark.textAlt),
  notesBorder: createColor(palette.gray.divider, palette.dark.techBorder),
  notesFilterUnselectBGColor: createColor(
    palette.opacity.gray80alt,
    palette.dark.content,
  ),
  notesTypeColor: createColor(palette.gray.darker, palette.dark.textAlt),
  notesDescColor: createColor(palette.gray.darker, palette.dark.textAlt),
  notesUserColor: createColor(palette.gray.darkest, palette.dark.text),
  notesUserBGColor: createColor(palette.gray.avatar, palette.dark.background),
  notesUserDate: createColor(palette.gray.dark, palette.dark.textAlt),
  titleCardActionColor: createColor(palette.blue.primary, palette.blue.primary),
  divider: createColor(palette.gray.extraLight, palette.dark.techBorder),
  separatorColor: createColor(palette.gray.divider, palette.dark.techBorder),
  workOrderFilterSelectedTextBorder: createColor(
    palette.blue.primary,
    palette.blue.primary,
  ),
  tabTextColor: createColor(palette.gray.darkest, palette.gray.darkest),
  tabTextSelectedColor: createColor(palette.blue.primary, palette.blue.primary),
  viewbackground: createColor(palette.gray.white, palette.dark.content),
  closeModalIconColor: createColor(
    palette.gray.darkest,
    palette.dark.background,
  ),
  notedModalBG: createColor(palette.gray.white, palette.dark.content),
  notesModalBorder: createColor(palette.gray.white, palette.dark.content),
  noteHeaderSeparator: createColor(
    palette.gray.extraLight,
    palette.dark.techBorder,
  ),
  notedModalMainTitle: createColor(palette.blue.onTint, palette.dark.text),
  cancelCTABorder: createColor(
    palette.gray.iconLight,
    palette.dark.background,
  ),
  cancelCTAText: createColor(palette.blue.primary, palette.dark.textAlt),
  tabIconSelectedColor: createColor(
    palette.blue.primary,
    palette.blue.primary,
  ),
  tabIconColor: createColor(palette.gray.darkest, palette.gray.darkest),
};
